// extracted by mini-css-extract-plugin
export default {"notificationMenu":"NotificationMenu_notificationMenu__9uJTt"};